//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets permissions for the current user
 */
export function getCurrentUserInfo(config?: AxiosRequestConfig | undefined): Promise<Types.CurrentUserDto> {
    let url_ = getBaseUrl() + "/api/users/me";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetCurrentUserInfo,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetCurrentUserInfo?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetCurrentUserInfo(_response);
    });
}

function processGetCurrentUserInfo(response: AxiosResponse): Promise<Types.CurrentUserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initCurrentUserDto(resultData200);
        return Promise.resolve<Types.CurrentUserDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.CurrentUserDto>(null as any);
}

/**
 * Allows user to reset their password using single-use password reset token issued by the backend.
 */
export function resetPassword(dto: Types.ResetPasswordDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/reset-password";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeResetPasswordDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigResetPassword,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigResetPassword?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processResetPassword(_response);
    });
}

function processResetPassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Changes password by a user.
 * @param dto The dto contains old and new passwords.
 */
export function changePassword(dto: Types.ChangePasswordDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/users/password";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeChangePasswordDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigChangePassword,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigChangePassword?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processChangePassword(_response);
    });
}

function processChangePassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetCurrentUserInfo: Partial<AxiosRequestConfig> | null;
export function getGetCurrentUserInfoRequestConfig() {
  return _requestConfigGetCurrentUserInfo;
}
export function setGetCurrentUserInfoRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetCurrentUserInfo = value;
}
export function patchGetCurrentUserInfoRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetCurrentUserInfo = patch(_requestConfigGetCurrentUserInfo ?? {});
}

let _requestConfigResetPassword: Partial<AxiosRequestConfig> | null;
export function getResetPasswordRequestConfig() {
  return _requestConfigResetPassword;
}
export function setResetPasswordRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigResetPassword = value;
}
export function patchResetPasswordRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigResetPassword = patch(_requestConfigResetPassword ?? {});
}

let _requestConfigChangePassword: Partial<AxiosRequestConfig> | null;
export function getChangePasswordRequestConfig() {
  return _requestConfigChangePassword;
}
export function setChangePasswordRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigChangePassword = value;
}
export function patchChangePasswordRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigChangePassword = patch(_requestConfigChangePassword ?? {});
}